@let loading = loading$ | async;

<ion-header>
  <ion-toolbar>
    <ion-title>Нова заявка</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <!-- Caller info -->
  <div class="caller-info anim-fade-in-up">
    <div class="caller-avatar">
      <ion-icon name="person-circle-outline"></ion-icon>
    </div>
    <div class="caller-details">
      @if (callerName) {
        <p class="caller-name">{{ callerName }}</p>
      }
      <p class="caller-phone">{{ call.phone }}</p>
    </div>
  </div>

  <!-- Form -->
  <form [formGroup]="form" (ngSubmit)="create()">

    <ion-list class="form-list stagger-in" lines="none">

      <ion-item class="form-item">
        <ion-label position="stacked">
          Причина звернення <span class="required">*</span>
        </ion-label>
        <ion-textarea
          formControlName="reason"
          placeholder="Опишіть причину звернення..."
          [autoGrow]="true"
          rows="3"
        ></ion-textarea>
        @if (form.controls.reason.invalid && form.controls.reason.touched) {
          <p class="error-text">Поле обов'язкове</p>
        }
      </ion-item>

      <ion-item class="form-item">
        <ion-label position="stacked">Вулиця</ion-label>
        <ion-input
          formControlName="street"
          placeholder="Вулиця"
          clearInput="true"
        ></ion-input>
      </ion-item>

      <ion-item class="form-item">
        <ion-label position="stacked">Місто</ion-label>
        <ion-input
          formControlName="city"
          placeholder="Місто"
          clearInput="true"
        ></ion-input>
      </ion-item>

    </ion-list>

    <ion-button
      expand="block"
      type="submit"
      class="submit-btn"
      [disabled]="loading"
    >
      @if (loading) {
        <ion-spinner name="crescent" slot="start"></ion-spinner>
        Створення...
      } @else {
        Створити заявку
      }
    </ion-button>

  </form>

</ion-content>
